import { Component, OnInit } from '@angular/core';
import {ApiPathsService} from "../../api-paths.service";
import { ApiRestService } from '../_services/api-rest.service';
import {DatePipe} from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { Bilancio } from '../Models/Bilancio';
import {ToastrService} from "ngx-toastr";





@Component({
  selector: 'app-lista-bilancio',
  templateUrl: './lista-bilanci.component.html',
  styleUrls: ['./lista-bilanci.component.scss']
})
export class ListaBilanciComponent implements OnInit {
    bilanci:any[]
    filtro:any = { page: 0, size: 10, periodo: true, inizio: '2024-01-01', fine: '2024-12-31' };
    stati: { id: string, label: string }[] = [{ id: 'N', label: 'In Lavorazione' }, { id: 'E', label: 'Validato'}, { id: 'I', label: 'Approvato'}, { id: 'P', label: 'Riesaminare'}];
    dropdownSettings = {
        singleSelection: true,
        singleOutput: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        idField: 'id',
        textField: 'label',
        allowSearchFilter: false,
    };
    constructor(
      private apiPaths:ApiPathsService, 
      private apiRestService:ApiRestService, 
      private datePipe:DatePipe,
      private route: ActivatedRoute,
      private router:Router,
      private toastService: ToastrService,

    ){

    }

    ngOnInit(){
        this.Refresh()
    
    }

    Refresh(){
        this.filtro.stato = this.filtro.statoObject?.id;
        this.apiRestService.getListaBilanci(this.filtro).subscribe( 
            data => {
                this.bilanci = data?.data
            }
        )
    }

    add(){
        this.router.navigate([`/primanota/bilancio`])
    }

    open(bilancio){
        this.router.navigate([`/primanota/bilancio/${bilancio.id}`])
    }

    delete(bilancio){
        if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
            this.apiRestService.deleteBilancio({id:bilancio.id}).subscribe(
                data=> {
                    this.toastService.success("Bilancio Eliminato Correttamente");
                    this.Refresh()
                }
            )
        }
    }




}
